import { createSlice } from '@reduxjs/toolkit'
import { ISlider } from 'models/Home/ISlider'
import { ISocialMedia } from 'models/Common/ISocialMedia'

export interface HomeState {
  isLoading: boolean
  isGetSliderSuccess: boolean
  isGetAboutSuccess: boolean
  isGetSocialMediaSuccess: boolean
  sliderData: ISlider[] | null
  socialMedia: ISocialMedia[] | null
}

const initialState: HomeState = {
  isLoading: false,
  isGetSliderSuccess: false,
  isGetAboutSuccess: false,
  isGetSocialMediaSuccess: false,
  sliderData: null,
  socialMedia: null,
}

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    apiRequest: (state) => {
      state.isLoading = true
    },
    apiFailure: (state) => {
      state.isLoading = false
    },
    getSlider(state, action) {
      state.isLoading = false
      state.isGetSliderSuccess = true
      state.sliderData = action.payload.sliderData.result
    },
    getSocialMedia(state, action) {
      state.isLoading = false
      state.isGetSocialMediaSuccess = true
      state.socialMedia = action.payload.socialMedia.result
    },
  },
})

export const { apiRequest, apiFailure, getSlider, getSocialMedia } =
  homeSlice.actions

export default homeSlice.reducer
